import React from "react";
import { observer } from "mobx-react";
import { observable } from "mobx";

import { Button, MenuItem, Paper } from "@material-ui/core";
import Grow from "@material-ui/core/Grow";

import SvgI24SortAsc from "assets/icons/I24SortAsc";
import SvgI24Check from "assets/icons/I24Check";

import OutsideClickHandler from "components/OutsideClickHandler";

import { DEFAULT_SORT_ITEMS } from "constants/sortConstants";
import { TableSortType } from "stores/templates/TableStore";

import {
  Popper,
  MenuList,
  CheckedIcon,
  IconContainer,
  IconGap,
} from "./styles";

type Props = {
  initValue?: TableSortType;
  disablePortal?: boolean;
  onApply: (value: TableSortType) => void;
};

type DefaultSortItemType = TableSortType & { text: string };

@observer
class SortingControl extends React.Component<Props> {
  @observable isMenuOpened: boolean = false;

  ref = React.createRef<HTMLButtonElement>();

  getIsChecked = (menuItem: any) => {
    const { initValue } = this.props;

    return (
      initValue &&
      initValue.column === menuItem.column &&
      initValue.desc === menuItem.desc
    );
  };

  toggleMenu = () => {
    this.isMenuOpened = !this.isMenuOpened;
  };

  closeMenu = () => {
    this.isMenuOpened = false;
  };

  onMenuClick = (menuItem: DefaultSortItemType) => () => {
    const { onApply } = this.props;

    onApply({ column: menuItem.column, desc: menuItem.desc });
    this.closeMenu();
  };

  render() {
    const { disablePortal } = this.props;

    return (
      <>
        <Button
          startIcon={<SvgI24SortAsc />}
          variant="text"
          color="secondary"
          onClick={this.toggleMenu}
          ref={this.ref}
        >
          Sort
        </Button>
        <Popper
          open={this.isMenuOpened}
          anchorEl={this.ref.current}
          placement="left-start"
          disablePortal={disablePortal}
          transition
        >
          {({ TransitionProps }) => (
            <Grow {...TransitionProps}>
              <Paper>
                <OutsideClickHandler onClick={this.closeMenu}>
                  <MenuList>
                    {DEFAULT_SORT_ITEMS.map((item: DefaultSortItemType) => (
                      <MenuItem
                        onClick={this.onMenuClick(item)}
                        key={`${item.column}_${item.desc}`}
                      >
                        {item.text}
                        <IconContainer>
                          {this.getIsChecked(item) ? (
                            <CheckedIcon>
                              <SvgI24Check />
                            </CheckedIcon>
                          ) : (
                            <IconGap />
                          )}
                        </IconContainer>
                      </MenuItem>
                    ))}
                  </MenuList>
                </OutsideClickHandler>
              </Paper>
            </Grow>
          )}
        </Popper>
      </>
    );
  }
}

export default SortingControl;
